import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import {
  ConfirmModalActions,
  ConfirmModalData
} from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { bindFunctionsToThis } from '../../../../common/extensions';
import { GoogleMapsService, TravelMode } from '../../../../common/services/google.maps.service';
import { ModalService } from '../../../../common/services/modal.service';
import { Attraction } from '../../../../models/hub/hub.tour';
import { EventTimeService } from '../../../../services/event.time.service';
import { HubApiService } from '../../../../services/hub.api.service';
import { ImageService } from '../../../../services/image.service';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import {
  AllFrontendSettingsStore,
  TravelModeStore,
  VisitorTripIdStore
} from '../../../../stores/visitor.calendar.store';
import { ShareTripModalComponent } from '../../../visitor/trip/share.trip.modal/share.trip.modal.component';
import {
  ShareTripModalActions,
  ShareTripModalData
} from '../../../visitor/trip/share.trip.modal/share.trip.modal.provider';

import { TripFloatDetailComponent } from '../../../visitor/trip/trip.float.detail/trip.float.detail.component';
import { EventDetailsModalActions } from "../../../visitor/event.details.modal/event.details.modal.provider";
import { EventDetailsModalComponent } from "../../../visitor/event.details.modal/event.details.modal.component";
import { HubEvent } from "../../../../models/hub/hub.event";
import { PlaceDetailsModalActions } from "../../../visitor/place.details.modal/place.details.modal.provider";
import { PlaceDetailsModalComponent } from "../../../visitor/place.details.modal/place.details.modal.component";
import { HubPlace } from "../../../../models/hub/hub.place";
import { AllFrontendSettingsCommand } from "../../../../commands/visitor/all.frontend.settings.command";
import { VisitorTripComponent } from "../../../visitor/trip/visitor.trip.component";

@Component({
  selector: 'ig-attraction-list',
  templateUrl: './attraction.list.component.html',
  styleUrls: ['./attraction.list.component.scss', '../../../../../node_modules/ng-drag-drop/style.css'],
  encapsulation: ViewEncapsulation.None
})
export class AttractionListComponent extends BaseComponent implements OnInit {

  public hubName: string;
  public detailAttraction: Attraction;
  public isUpdating = false;
  public isDragging = false;
  public totalTravelTime = 0;
  public totalTravelTimeText = '';
  public totalDistance = 0;
  public totalDistanceMiles = '';
  public totalDistanceKM = '';
  public travelMode = TravelMode.DRIVING;
  public dayExpanded = [];
  public detailsStyle = 'popup';
  @Input() public tour: any;
  @Input() public tripID: string;
  @Input() public isDraggable = false;
  @Input() public isDisabled = false;
  @Input() public type = 'tour';
  @Input() public isShowAddtoMyTrip = true;
  @Input() public isShareable = false;
  @Output() reordered: EventEmitter<any> = new EventEmitter();
  @Output() onready: EventEmitter<any> = new EventEmitter();
  @Output() removeFromTrip: EventEmitter<any> = new EventEmitter();
  @Output() showRouteOnMapMobile: EventEmitter<any> = new EventEmitter();
  @Output() showInfoWindowOnMap = new EventEmitter<Number>();
  @ViewChild('attraction') wholeAttraction: ElementRef;
  @ViewChild('routemaptrigger') routeMapTrigger: ElementRef;
  @ViewChild('details') detailsPanel: TripFloatDetailComponent;
  @ViewChildren('attractionwrap') attractionWrap: QueryList<ElementRef>;
  @ViewChildren('swaps') swaps: QueryList<ElementRef>;
  @Output() onAddToTrip: EventEmitter<any> = new EventEmitter();
  @Output() onShowDetail: EventEmitter<any> = new EventEmitter();
  @Output() onFloatDetailClose: EventEmitter<any> = new EventEmitter();

  //@Output() onRemoveFromTrip: EventEmitter<any> = new EventEmitter();

  constructor(private imageService: ImageService,
              private activatedRoute: ActivatedRoute,
              private hubApiService: HubApiService,
              private visitorApiService: VisitorApiService,
              private googleMapService: GoogleMapsService,
              private visitorTripIdStore: VisitorTripIdStore,
              private allFrontendSettingsStore: AllFrontendSettingsStore,
              private travelModeStore: TravelModeStore,
              private modalService: ModalService) {
    super({activatedRoute});
    bindFunctionsToThis(this);
  }

  public ngOnInit() {
    let {hubName, tripId} = this.allRouteParams;
    this.hubName = hubName;
    this.tripID = tripId;

    this.tour.days = [{
      title: 'Day 1',
      attractions: []
    }, {
      title: 'Day 2',
      attractions: []
    }];
    this.tour.attractions.forEach((x, index) => {
      if (index <= this.tour.attractions.length / 2) {
        this.tour.days[0].attractions.push(x);
      } else {
        this.tour.days[1].attractions.push(x);
      }
    });
    this.dayExpanded.push(false);
    this.dayExpanded.push(false);

    this.travelTime();

    //this.setSwapIcon();

    this.visitorTripIdStore.tripIdCommand.takeUntil(this.isDestroyed).subscribe(tripId => {
      this.tripID = tripId.tripId;
    });

    this.travelModeStore.modeCommand.takeUntil(this.isDestroyed)
      .subscribe((mode: TravelMode) => {
        if (mode !== this.travelMode) {
          this.travelMode = mode;
          this.travelTime();
        }
      });

    this.allFrontendSettingsStore.allFrontendSettingsCommand.takeUntil(this.isDestroyed)
      .subscribe((command: AllFrontendSettingsCommand) => {
        if (command.customSettings) {
          this.detailsStyle = command.customSettings.tripPlannerDetailsStyle;
        }
      });
  }

  public get travelModeIcon() {
    if (this.travelMode === TravelMode.DRIVING) return 'directions_car';
    if (this.travelMode === TravelMode.BICYCLING) return 'directions_bike';
    if (this.travelMode === TravelMode.WALKING) return 'directions_walk';
    return 'menu';
  }

  public changeTravelMode(mode: TravelMode | string) {
    this.travelMode = mode as TravelMode;
    this.travelTime();
    this.travelModeStore.modeCommand.next(this.travelMode);
  }

  public removeFromTour($event, id: string) {
    if ($event) {
      $event.stopPropagation();
    }
    if (!this.isDraggable) {
      return;
    }
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        this.detailsPanel.closeDetails();
        this.removeFromList(id, event);
      }
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: `Are you sure you want to remove this item from the ${this.type}?`,
      confirmModalConfirmButtonText: 'Remove',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        {provide: ConfirmModalActions, useValue: actions},
        {provide: ConfirmModalData, useValue: data}
      ]
    });
  }

  public dragEnter($event) {
    console.log('enter');
    if ($event && $event.currentTarget) {
      this.restoreItemStyle();
      $event.currentTarget.style.border = '2px dashed green';
    }
  }

  public startDrag($event) {
    if (!this.isDragging) {
      this.isDragging = true;
    }
  }

  public onItemDrop(e: any, targetIndex: number) {
    this.isDragging = false;
    this.restoreItemStyle(true);
    this.reorderTour(e, targetIndex);

    if (this.type === 'trip') {
      this.travelTime();
      //if (!this.isMobile) {
      setTimeout(() => {
        this.reordered.emit({type: this.type, attractions: this.tour.attractions});
      }, 200);
      //}
    } else {
      this.isUpdating = true;
      this.hubApiService.updateTourAttractions(this.hubName,
        {id: this.tour._id, attraction: this.tour.attractions})
        .subscribe(() => {
          this.travelTime();
          setTimeout(() => {
            this.reordered.emit(this.tour.attractions);
          }, 200);
          setTimeout(() => {
            this.isUpdating = false;
          }, 500);
        });
    }
  }

  public showRouteOnMapForMobile() {
    //this.parent.parent.showDirectionMap(this.tour);
    //this.visitorTrip.showDirectionMap(this.tour);
    this.showRouteOnMapMobile.emit(this.tour);
  }

  public travelTime() {
    this.totalTravelTimeText = '...';
    this.totalTravelTime = 0;
    this.totalDistance = 0;
    this.totalDistanceMiles = '...';
    this.totalDistanceKM = '...';
    let waypoints = [];

    if (this.tour.attractions.length < 2) {
      return;
    }

    this.tour.attractions.forEach(x => {
      waypoints.push(`${x.item.address.lat || x.item.lat},${x.item.address.lng || x.item.lng}`);
    });

    this.googleMapService.getDirection(this.tour.attractions, this.travelMode, response => {
      if (response && response.legs && response.legs.length) {
        this.totalTravelTime = 0;
        this.totalDistance = 0;
        for (let leg of response.legs) {
          this.totalTravelTime += leg.duration.value;
          this.totalDistance += leg.distance.value;
          console.log('leg.distance.value', leg.distance.value);
        }
        this.totalTravelTime = Math.round(this.totalTravelTime / 60);
        this.totalTravelTimeText = EventTimeService.convertToTravelTimeText(this.totalTravelTime);
        this.totalDistanceMiles = Math.round(this.totalDistance / 1610) + ' miles';
        this.totalDistanceKM = Math.round(this.totalDistance / 1000) + ' km';
        console.log('total totalDistanceKM', this.totalDistance);
        if (this.type === 'tour') {
          this.hubApiService.updateTourTravelTimeAndDistance(this.hubName, this.tour._id, this.totalTravelTime, this.totalDistance, this.tour.attractions.length).subscribe(() => {
          });
        }
        this.onready.emit();
      }
    });
  }

  public enpandAll() {
    this.dayExpanded[0] = true;
    this.dayExpanded[1] = true;
  }

  public dayDragEnter(dayIndex) {
    this.dayExpanded[dayIndex] = true;
  }

  public showDetails(item: any) {
    this.onShowDetail.emit(item);
    if (this.isMobile) return;

    if (this.detailsStyle === 'float') {
      this.detailsPanel.showDetails(item, '100%', '0');
      // this.detailsPanel.showDetails(item, this.isMobile ? '0' : '100%', this.isMobile ? '57px' : '0');
      return;
    }

    item.item.hubName = this.hubName;

    if (item.item.startTime) {
      let actions = <EventDetailsModalActions>{
        confirm: (event: ButtonTriggerEvent, data: any) => {
        }
      };

      this.modalService.show({
        component: EventDetailsModalComponent,
        providers: [
          {provide: EventDetailsModalActions, useValue: actions},
          {provide: HubEvent, useValue: item.item},
        ],
        panelClass: 'modal-fixed-top-lower'
      });
      return;
    }

    let actions = <PlaceDetailsModalActions>{
      confirm: (event: ButtonTriggerEvent, data: any) => {
      }
    };

    this.modalService.show({
      component: PlaceDetailsModalComponent,
      providers: [
        {provide: PlaceDetailsModalActions, useValue: actions},
        {provide: HubPlace, useValue: item.item},
      ],
      panelClass: 'modal-fixed-top'
    });
  }

  public swap(index) {
    if (!this.tour.attractions.length || this.tour.attractions.length <= index) {
      return;
    }

    this.onItemDrop({
      dragData: {
        order: index + 1
      }
    }, index);

    //this.setSwapIcon();
  }

  public showOnMap() {
    this.showInfoWindowOnMap.emit(this.detailAttraction.order);
    this.detailsPanel.closeDetails();
  }

  public addToTrip($event) {
    this.onAddToTrip.emit($event);
  }

  public floatDetailClose() {
    this.onFloatDetailClose.emit();
  }

  public removeFromTripAtTour(id) {
    if (this.type === 'trip') {
      this.removeFromTour(null, id);
      //this.removeFromList(id);
    } else {
      this.removeFromTrip.emit(id);
    }
  }

  // public shareTrip() {
  //     this.showShareTripModal('trip');
  // }
  //
  public shareTour() {
    this.showShareTripModal('tour');
  }

  private showShareTripModal(type) {
    let {tripId, hubName} = this.allRouteParams;
    let actions = <ShareTripModalActions>{
      confirm: (event: ButtonTriggerEvent, social) => {
      }
    };
    this.modalService.show({
      component: ShareTripModalComponent,
      providers: [
        {provide: ShareTripModalActions, useValue: new ShareTripModalActions()},
        {
          provide: ShareTripModalData,
          useValue: new ShareTripModalData(type === 'trip' ? (tripId || this.tripID) : this.tour._id, hubName, type, false, '', '', 0)
        }
      ]
    });

  }

  private setSwapIcon() {
    setTimeout(() => {
      if (this.swaps) {
        this.swaps.forEach((x, index) => {
          x.nativeElement.style.top = `${113 * index + 100}px`;
        });
      }
    });
  }

  public removeFromList(id, event?) {
    if (this.type === 'trip') {
      this.removeFromTrip.emit(id);
      let index = this.tour.attractions.getElementIndex(x => x.feedId === id);

      this.attractionWrap.toArray()[index].nativeElement.style.opacity = '0';
      setTimeout(() => {
        this.tour.attractions.splice(index, 1);
        this.travelTime();
      }, 500);

      if (event) {
        event.complete();
      }
      return;
    }
    this.hubApiService.removeAttractionFromTour(this.hubName,
      {id: this.tour._id, attractionId: id})
      .finally(event && event.complete)
      .subscribe(() => {
        this.detailsPanel.closeDetails();
        this.hubApiService.getTourDetail(this.hubName, this.tour._id, this.type === 'trip').subscribe(tour => {
          this.tour = tour;
          this.removeFromTrip.emit(tour);
          this.travelTime();
        });
      });
  }

  private reorderTour(e, targetIndex) {
    this.sortAtrractionItem();
    let temp = this.tour.attractions[e.dragData.order];
    this.tour.attractions[targetIndex].order = e.dragData.order;
    this.tour.attractions[e.dragData.order] = this.tour.attractions[targetIndex];
    temp.order = targetIndex;
    this.tour.attractions[targetIndex] = temp;
  }

  private sortAtrractionItem() {
    if (this.tour && this.tour.attractions.length) {
      this.tour.attractions.forEach((x, index) => {
        x.order = index;
      });
    }
  }

  private restoreItemStyle(isOnDrop = false) {
    this.attractionWrap.toArray().forEach(x => {
      x.nativeElement.style.border = '2px dashed white';
      if (isOnDrop) {
        x.nativeElement.style.borderBottom = '1px dashed lightgray';
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/tours/attractions/attraction.list.component.ts